<template>
  <div>
    <div  class="adre">
      <mt-header fixed title="申请开站">
        <mt-button icon="back" slot="left" @click="goback"></mt-button>
      </mt-header>
      <div class="ress" id="shen">
        <mt-field
          label="申请人姓名"
          placeholder="请输入申请人"
          v-model="shenList.truename"
        ></mt-field>
        <mt-field
          label="手机号码"
          placeholder="请输入手机号码"
          v-model="shenList.phone"
        ></mt-field>
        <mt-field
          label="站点名称"
          placeholder="请输入名称"
          type="text"
          v-model="shenList.sitename"
        ></mt-field>

        <mt-field
          label="备注"
          placeholder="请输入备注"
          v-model="shenList.descs"
        ></mt-field>

        <p>
          <mt-button @click="shen(shenList)">提交</mt-button>
        </p>
      </div>
    </div>

  </div>
</template>
<script>
import Bus from "@/bus.js";
import areaList from "../../assets/citys.js";
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      activeName: ["1"],
      uploadDis: false,
      shenList: {},
      pathname: "",
      area: areaList,
      areaNames: "",
      popup1show: false,
      showArea: false,
      sheetVisible: false,
      personVisible: false,
      type: "",
      person: {
        nickname: "",
        descs: "",
        avaterurl: "",
      },
      token: "",
      imgFile: [],
      addressList: {
        idcardimg1: "",
        idcardimg2: "",
        detail: "",
        name: "",
        idcard: "",
        phone: "",
        city: "",
        province: "",
        region: "",
        // ischeck: ""
      },
      form: {},
      myaddress: [],
      addedit: [],
      list: {},
      you: "",
      keys: "",
    };
  },
  created() {
   
  },
  methods: {
    goback() {
        this.$router.go(-1);
    },
    shen(e) {
      var token = localStorage.getItem("loginMobile");
      if (
        e.truename == null ||
        e.truename == undefined ||
        e.phone == null ||
        e.phone == undefined ||
        e.sitename == null ||
        e.sitename == undefined
      ) {
        Toast({ message: "请完善信息", position: "bottom", duration: 3000 });
        return false;
      } else {
        e.token = token;
        this.$api.post(this.$api.base, "/wxapi/dian/add", e, (r) => {
          if (r.data.status == 200) {
            setTimeout(() => {
              Toast({ message: "申请成功", icon: "success", duration: 3000 });
            }, 100);
            this.$router.push("/MyIndex");
 
          } else{
            setTimeout(() => {
              Toast({ message: "申请失败", icon: "fail", duration: 3000 });
            }, 100);
          } 
        });
      }
    },
    
  },
};
</script>
<style  lang="scss" scoped>
@import "../../scss/my";
</style>